var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.9998 15.2c3.9765 0 7.2-3.2235 7.2-7.19995s-3.2235-7.200001-7.2-7.200001c-3.97645 0-7.199995 3.223551-7.199995 7.200001s3.223545 7.19995 7.199995 7.19995zm3.3364-8.36356c.3515-.35147.3515-.92132 0-1.27279s-.9213-.35147-1.2728 0l-2.9636 2.96361-1.1636-1.16361c-.35147-.35147-.92132-.35147-1.27279 0s-.35147.92132 0 1.2728l1.8 1.79995c.35147.3515.92132.3515 1.27279 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.1d75884e706154053b78ee3902949c83.svg";
export { ForwardRef as ReactComponent };